<template>
    <div class="fac-switch" :class="design">
        <div v-if="!list">
            <input type="checkbox" :name="name" :id="id" @change="onChange" v-model="checkeds">
            <label :for="id">
                <span v-if="textOn">{{textOn}}</span>
                <span v-if="textOff">{{textOff}}</span>
            </label>
        </div>
        <div v-if="list">
            <input type="checkbox" :name="name" :id="id" @change="onChange" :value="val"  v-model="checkeds" :disabled="disabled" >
            <label :for="id">
                <span v-if="textOn">{{textOn}}</span>
                <span v-if="textOff">{{textOff}}</span>
            </label>
        </div>
        <div v-if="label">{{label}}</div>
    </div>
</template>

<script>
	export default {
        name: 'fac-switch',
        props: {
			id: {
				type: String,
				required: true,
            },
            label: {
				type: String,
				required: false,
            },
            val: {
                type: String,
                required: false,
            },
            value: {
                required: false,
            },
            name: {
				type: String,
				required: false,
            },
            design: {
				type: String,
				required: false,
            },
            textOff: {
				type: String,
				required: false,
            },
            disabled: {
                type: Boolean,
                required: false,
            },
            textOn: {
				type: String,
				required: false,
            },
            checked: {
				type: Boolean,
				required: false,
            },
            list: {
				type: Boolean,
				default: false,
            },
        },
        computed: {
            checkeds: {
                get() {
                    return this.value
                },
                set(val) {
                    this.listCheckeds = val
                }
            }
        },
        data(){
            return {
                listCheckeds: false,
            }
        },
        methods: {
			onChange (event) {
                if(this.list){
                    this.$emit('input', this.listCheckeds)
                }else{
                    this.$emit('input', event.target.checked)
                }
            }
		}
    };
</script>

<style lang="stylus">
    @import './styles.styl';
</style>